<template>
    <div>
        <div v-if="loading">Loading list...</div>
        <div v-if="!loading && (items == undefined || items.length == 0)">Der er ingen kurser i listen...</div>
        <div class="list-view" v-if="!loading && selectedItem == undefined">
            <div class="grid-container">
                <div class="grid-x">
                    <div class="cell large-8">
                        <div v-html="breadcrumb">
                        </div>
                        <h1 class="list-view__title">{{ title }}</h1>
                        <h2 class="abstract" v-html="manchet"></h2>
                        <div class="course-list-search">
                            <div class="course-list-search__input-group">
                                <label for="courseSearchInput">Indtast del af kursusnavn</label>
                                <input type="text" id="courseSearchInput" v-model="search" v-on:blur="HideSearchResults" v-on:focus="ShowSearchResults" autocomplete="off" />
                            </div>
                            <div class="course-list-search__button-group">
                                <button v-on:click="SubmitSearch">Se kurser</button>
                            </div>
                        </div>
                        <div class="course-list-search-results" v-if="searchedItems.length > 0" v-bind:class="{ hidden: !showSearchResults }">
                            <ul v-bind:style="{ width: resultsWidth + 'px' }">
                                <li v-for="item in searchedItems" v-on:click="SelectItem(item)">
                                    <a>
                                        {{ item.name }} <span>({{ item.provider }})</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div class="course-list-items">
                            <ul class="list-view__items" v-if="shownItems.length > 0">
                                <li v-for="item in shownItems" class="course-list-item">
                                    <a class="list-item" v-on:click="SelectItem(item)">
                                        <span class="list-item__date">{{ item.approvedYear }}</span>
                                        <p class="list-item__title">
                                            {{ item.name }}
                                        </p>
                                        <p class="course-list-item__provider">{{ item.provider }}</p>
                                        <span class="list-item__arrow"></span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <template>
                            <div class="course-list-text-section" v-html="textSection">
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <div class="page course-page" v-if="!loading && selectedItem != undefined">
            <section class="section-header">
                <div class="grid-container">
                    <div class="section-header__inner">
                        <template>
                            <div v-html="breadcrumb">
                            </div>
                        </template>
                        <a class="section-header__back" v-on:click="DeselectItem" >Tilbage</a>
                        <h1 class="section-header__title section-header__compressed">{{selectedItem.name }}</h1>
                    </div>
                </div>
            </section>

            <div class="grid-container grid-container--no-padding-mobile">
                <div class="content">
                    <div class="grid-x">
                        <div class="cell large-8">
                            <div class="content__body">
                                <div class="content__panel">
                                    <div class="content__meta">
                                        <div class="published">
                                            <span>Udbyder:</span>
                                            <span class="published__date">{{ selectedItem.provider }}</span>
                                        </div>
                                        <div class="published">
                                            <span>Antal lektioner:</span>
                                            <span class="published__date">{{ selectedItem.lessonsAmount }}</span>
                                        </div>
                                        <div class="published">
                                            <span>Godkendt år:</span>
                                            <span class="published__date">{{ selectedItem.approvedYear }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    
    /* IE POLYFILLS */
    import 'es6-promise/auto';
    require("jspolyfill-array.prototype.findIndex");
    require("jspolyfill-array.prototype.find");

    export default {
        name: "ListViewComponent",
        props: ["coursesFileUrl", "title", "manchet", "textSection", "breadcrumb","endpoint"],
        data() {
            return {
                error: false,
                loading: true,
                resultsWidth: 0,
                search: "",
                showSearchResults:false,
                searchedItems: [],
                shownItems: [],
                items: [],
                selectedItem: undefined,
            };
        },
        methods: {
            GetList() {
                axios
                    .get(this.endpoint, {
                        params: {
                            fileUrl: this.coursesFileUrl
                        },
                    })
                    .then((response) => {
                        this.items = response.data;
                        this.loading = false;
                        var searchIndex = window.location.search.indexOf("?search=");
                        var idIndex = window.location.search.indexOf("?id=");
                        if (idIndex > -1) {
                            idIndex = idIndex + 4;
                            var paramValue = window.location.search.substr(idIndex, window.location.search.length - idIndex);
                            var id = parseInt(paramValue);
                            this.SelectItemById(id);
                        } else if (searchIndex > -1) {
                            searchIndex = searchIndex + 8;

                            var searchValue = decodeURIComponent(window.location.search.substr(searchIndex, window.location.search.length - searchIndex));
                            this.search = searchValue;
                            this.SearchItems();
                            this.SubmitSearch();
                        }
                    })
                    .catch((er) => {
                        this.error = true;
                    })
                    .then(function () { });
            },
            SelectItemById(id) {
                var item = this.items.find(item => item.id == id);
                if (item != undefined) {
                    this.SelectItem(item);
                }
            },
            SelectItem(item) {
                this.selectedItem = item;
                var newUrl = window.location.pathname;
                if (newUrl.indexOf('?id=') == -1) {
                    newUrl = newUrl + "?id=" + item.id;
                    window.history.replaceState(window.location.pathname, document.title, newUrl);
                }
            },
            DeselectItem() {
                this.selectedItem = undefined;
                var newUrl = window.location.pathname;
                if (this.search.length >= 5) {
                    newUrl = newUrl + "?search=" + this.search;
                }
                window.history.replaceState(window.location.pathname, document.title, newUrl);
            },
            SearchItems() {
                if (this.search.length >= 5) {
                    this.searchedItems = this.items.filter(item => item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1);
                    this.SetSearchResultsWidth();
                } else {
                    if (this.searchedItems.length > 0) {
                        this.searchedItems = [];
                    }
                }
            },
            HideSearchResults() {
                var timer = setTimeout(() => {
                    this.showSearchResults = false;
                }, 100);
            },
            ShowSearchResults() {
                this.SetSearchResultsWidth();
                this.showSearchResults = true;
            },
            SubmitSearch() {
                this.shownItems = this.searchedItems;
                window.history.replaceState(window.location.pathname, document.title, window.location.pathname + "?search=" + this.search);
                this.HideSearchResults();
            },
            SetSearchResultsWidth() {
                var inputGroup = document.querySelector('.course-list-search__input-group');
                var buttonGroup = document.querySelector('.course-list-search__button-group');
                if (this.searchedItems.length > 0 && inputGroup != null && buttonGroup != null) {
                    this.resultsWidth = inputGroup.clientWidth + buttonGroup.clientWidth - 2; // minus 2 to subtract side borders
                } else {
                    this.resultsWidth = 0;
                }
            }
        },
        mounted() {
            this.GetList();
        },
        watch: {
            search: function() {
                this.SearchItems();
            }
        },
    };
</script>